<template>
  <el-container >

    <!-- 头部板块 -->
    <el-header>
      <div class="header-zwfwtext-box"></div>
      <div class="menu-button" @click="drawer = true"></div>
    </el-header>

    <!-- 右侧抽屉 -->



 
    <el-drawer
      title="我是标题"
      size="70%"
      :visible.sync="drawer"
      :with-header="false">

      <drawer_icon_list></drawer_icon_list>

      <el-collapse accordion>

        <el-collapse-item  title="自然资源局分局、县区局" class="collapse-title">
          <!-- 自然资源局分局卡片组件 -->
          <left_zrzyjfj_list></left_zrzyjfj_list>
        </el-collapse-item >
    
        <el-collapse-item title="不动产受理点" class="collapse-title">
          <!-- 不动产受理点卡片组件 -->
          <left_bdcsld_list></left_bdcsld_list>
        </el-collapse-item>

        <el-collapse-item title="2023年度“招拍挂”公开出让计划" class="collapse-title">
          <!-- 2023年度“招拍挂”公开出让计划卡片组件 -->
          <left_crjh_list></left_crjh_list>
        </el-collapse-item>

      </el-collapse>
      
    </el-drawer>


    <el-container>
      <!-- 地图板块 -->
      <el-main>
        <iframe src="https://www.nnrig.com/special_map/generalMap.html" seamless frameborder ></iframe>
      </el-main>
    </el-container>

    <div>
      <ul class="topnav">
        <li>
          <a href="http://zrzyj.nanning.gov.cn" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/HomePage.png">
            <br>
            <span>网站首页</span>
          </a>
        </li>

        <li>
          <a href="http://zrzyj.nanning.gov.cn/bjgk/" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/Overview.png">
            <br>
            <span>本局概况</span>
          </a>
        </li>

        <li>
          <a href="http://zrzyj.nanning.gov.cn/zwgk_57/zcfg/" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/GovernmentInformation.png">
            <br>
            <span>信息公开</span>
          </a>
        </li>

        <li>
          <a href="http://nn.zwfw.gxzf.gov.cn/gxzwfw/bmft/bmftList.do?deptCode=11450100007575907U&webId=10" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/WebsiteServices.png">
            <br>
            <span>网上办事</span>
          </a>
        </li>

        <li>
          <a href="http://zrzyj.nanning.gov.cn/bsfw_57/" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/Exchange.png">
            <br>
            <span>办事服务</span>
          </a>
        </li>

      </ul>
    </div>

  </el-container>
</template>

<script>
  import zwfwmap_phone from "./zwfwmap_phone";
  export default zwfwmap_phone;

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1, h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}

.el-container{
  overflow: hidden;
}
/* 头部板块 */
.el-header{
  position:relative;
  background-color: #4989de;
  color: #333;
  text-align: center;
  height: 4rem !important;
  line-height: 4rem;
}

/* 头部政务服务地图字体图片容器*/
.header-zwfwtext-box{
  position:absolute;
  width: 10rem;
  height: 2rem;
  left: 0;
  top: 2;
  right: 0;
  bottom: 0;
  margin: 0.2rem auto;
  background-image: url('../../assets/header_zwfwdt.png');
  background-size:100% 100%;
  background-repeat:no-repeat;
  background-position:center; 
}

/* 头部菜单按钮*/
.menu-button{
  position:absolute;
  text-align: left;
  top: 2.2rem;
  right: 0.7rem;
  width: 1.5rem;
  height: 1.5rem;
  background-image: url('../../assets/menu.png');
  background-size:100% 100%;
  background-position:center; 
}

/* 右侧抽屉 */

.collapse-title /deep/ .el-collapse-item__header{
  font-size: 0.9rem;
  margin-left: 1.7rem;
}


/* 地图板块 */
.el-main {
  width: 100%;
  height: 100%;
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  padding: 0;
  margin: 0;
  border: 0;
}
.el-main iframe{
  width: 100%;
  height: 100%;
}
.el-main::-webkit-scrollbar{
  display:none;
}
.el-container {
  height: 100%;
}

/* 导航条 */
.topnav {
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  text-align: center;
  height: 50px;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.topnav li{
  display: inline-block;
  vertical-align: middle;
  line-height: 0.8rem;
  height: 4rem;
  margin-left: 0.6rem;
  margin-right: 0.6rem;
  margin-top: 0.3rem;
}
 
/* 导航链接 */
.topnav a {
  text-align: left;
  top: 0;
  left: 0;
  font-size: 0.2rem;
  color: black;
  text-decoration :none;
}

/* 导航链接图片 */
.topnav img{
  zoom: 0.6;
  margin-top: -0.26042vw;
  height: 35px;
}

</style>



// WEBPACK FOOTER //
// src/components/zwfwmap-phone/zwfwmap_phone.vue